import React, { useEffect, useState } from "react";
import { Container, Row, Card, Button } from "shards-react";
import { useQuery, gql } from "@apollo/client";
import PageTitle from "../../components/common/PageTitle";
import {
  AppBar,
  Grid,
  makeStyles,
  TextField,
  Toolbar,
  CircularProgress,
  Select,
  MenuItem,
  Typography,
  Table,
  IconButton
} from "@material-ui/core";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import BusinessIcon from "@material-ui/icons/Business";
import Mail from "@material-ui/icons/Mail";
import Phone from "@material-ui/icons/Phone";
import TodayIcon from "@material-ui/icons/Today";
import LanguageIcon from "@material-ui/icons/Language";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ListIcon from "@material-ui/icons/List";
import GridOnIcon from "@material-ui/icons/GridOn";
import ProdectListView from "./ProdectListView";
import { Person, Work } from "@material-ui/icons";
const baseUrl = process.env.REACT_APP_API_URI;

const useStyles = makeStyles(theme => ({
  card: {
    padding: "20px",
    width: "100%"
  },
  bannerImage: {
    height: "200px",
    width: "100%",
    border: "1px solid gray"
  },
  meetingId: {
    color: "red",
    fontSize: "25px",
    fontWeight: "bolder"
  },
  image: {
    height: "150px",
    width: "100%",
    borderRadius: "10px"
  },
  sectionhead: {
    color: "#3D5170",
    fontWeight: "bold",
    borderBottom: "1px solid #3D5170"
  },
  head: {
    color: "#3D5170",
    fontWeight: "bold"
  },
  weave: {
    backgroundColor: "#eee",
    padding: "5px",
    borderRadius: "5px"
  },
  season: {
    border: "1px solid #eee",
    padding: "4px",
    borderRadius: "5px"
  },
  icon: {
    marginRight: "5px",
    fontSize: "16px"
  },
  date: {
    backgroundColor: "#FFFFFF",
    borderRadius: "5px",
    padding: "5px",
    border: "1px solid #3D5170"
  },
  menuicon: {
    color: "#3D5279"
  }
}));

export default function ViewMeetingNote(props) {
  const [viewType, setViewType] = useState("list");

  const classes = useStyles();

  const MEETINGNOTE = () => gql`
    query GetMeetinNotes {
      meetingNote(id: ${props.match.params.id}) {
        MeetingRemarks
        updated_at
        id
        customer {
          id
          FullName
          Mobile
          Email
          Company
          Designation
          Country
        }
        added_by {
          username
        }
        ProductNotes {
          id
          ProposedCost
          ProductNotes
          ProposedQty
          product {
            Name
            Description
            category{
              Name
            }
            Weave
            Plates
            Season
            Color
            Images{
              url
            }
          }
        }
        Images {
          formats
          url
        }
      }
    }
  `;
  const { loading, error, data } = useQuery(MEETINGNOTE());

  return (
    <Container fluid className="main-content-container px-4">
      {loading ? (
        <CircularProgress />
      ) : data && data.meetingNote ? (
        <>
          <Grid container>
            <Grid container lg={6} md={6} sm={6}>
              <Row noGutters className="page-header py-4">
                <PageTitle
                  sm="4"
                  title={
                    data.meetingNote.customer &&
                    data.meetingNote.customer.Company
                  }
                  subtitle=""
                  className="text-sm-left"
                />
              </Row>
            </Grid>
            <Grid container lg={6} md={6} sm={6} alignItems="center">
              <Grid container direction="row-reverse">
                <Typography
                  className={classes.date}
                  style={{ marginLeft: "10px" }}
                >
                  <AccessTimeIcon className={classes.icon} />
                  {moment(data.updated_at).format("hh:MM a")}
                </Typography>
                <Typography className={classes.date}>
                  <TodayIcon className={classes.icon} />
                  {moment(data.updated_at).format("DD/MM/YYYY")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item container lg={6} md={6} alignItems="flex-start">
              <Grid container>
                <Typography>
                  <Person className={classes.icon} />
                  {data.meetingNote.customer &&
                    data.meetingNote.customer.FullName}
                </Typography>
                <Grid container>
                  <Typography>
                    <Work className={classes.icon} />
                    {data.meetingNote.customer &&
                      data.meetingNote.customer.Designation}
                  </Typography>
                </Grid>
                <Grid container>
                  <Typography>
                    <Mail className={classes.icon} />
                    {data.meetingNote.customer &&
                      data.meetingNote.customer.Email}
                  </Typography>
                </Grid>
                <Typography>
                  <Phone className={classes.icon} />
                  {data.meetingNote.customer &&
                    data.meetingNote.customer.Mobile}
                </Typography>
                <Grid container>
                  <Typography>
                    <LanguageIcon className={classes.icon} />
                    {data.meetingNote.customer &&
                      data.meetingNote.customer.Country}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container lg={6} md={6}>
              <Grid container spacing={1} direction="row-reverse">
                {data.meetingNote.Images &&
                  data.meetingNote.Images.map(image => (
                    <Grid item lg={4} key={image.url} container>
                      <img
                        className={classes.image}
                        src={
                          image.formats["thumbnail"]
                            ? image.formats["thumbnail"].url
                            : image.url
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </Grid>
            <Grid item container>
              <Typography className={classes.sectionhead}>
                Meeting remarks
              </Typography>
            </Grid>
            <Grid item container>
              <Typography>{data.meetingNote.MeetingRemarks}</Typography>
            </Grid>

            {/* </Grid> */}
            <Grid
              item
              container
              lg={6}
              md={6}
              sm={6}
              xs={6}
              alignItems="flex-start"
            >
              <Typography className={classes.sectionhead}>Products</Typography>
            </Grid>
            <Grid
              item
              container
              justifyContent="space-between"
              lg={6}
              md={6}
              sm={6}
              xs={6}
            >
              <Grid
                container
                direction="row-reverse"
                spacing={3}
                alignItems="flex-start"
              >
                <Grid item>
                  <IconButton
                    style={{
                      backgroundColor: viewType == "list" ? "gray" : "#fff"
                    }}
                    onClick={() => setViewType("list")}
                  >
                    <ListIcon
                      className={classes.menuicon}
                      style={{ color: viewType == "list" ? "#fff" : "#3D5279" }}
                    />
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton
                    style={{
                      backgroundColor: viewType == "card" ? "gray" : "#fff"
                    }}
                    onClick={() => setViewType("card")}
                  >
                    <GridOnIcon
                      className={classes.menuicon}
                      style={{ color: viewType == "card" ? "#fff" : "#3D5279" }}
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            {viewType == "list" && (
              <ProdectListView products={data.meetingNote.ProductNotes} />
            )}
            {viewType == "card" &&
              data.meetingNote.ProductNotes &&
              data.meetingNote.ProductNotes.map(note => (
                <Grid item container lg={4} md={4} sm={6} key={note.id}>
                  <Card
                    small
                    className="card-post h-100 "
                    style={{ padding: "10px", width: "100%", color: "#3D5170" }}
                  >
                    <Grid container spacing={1} style={{ fontSize: "14px" }}>
                      {note.product &&
                        note.product.Images &&
                        note.product.Images.map(image => (
                          <Grid item container justifyContent="center">
                            <img
                              style={{ height: "250px", width: "80%" }}
                              src={image.url}
                            />
                          </Grid>
                        ))}
                      <Grid container item>
                        <Typography className={classes.head}>
                          {note.product ? note.product.Name : note.id}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Grid className={classes.weave}>
                          {note.product && note.product.Weave}
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid className={classes.season}>
                          {note.product && note.product.Season}
                        </Grid>
                      </Grid>
                      <Grid container item>
                        Color: {note.product && note.product.Color}
                      </Grid>

                      <Grid container item>
                        Number of plates: {note.product && note.product.Plates}
                      </Grid>
                      <Grid container item>
                        Proposed qty: {note.ProposedQty}
                      </Grid>
                      <Grid container item>
                        Proposed cost: {note.ProposedCost}
                      </Grid>
                      <Grid container item>
                        Product notes: {note.ProductNotes}
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      ) : null}
    </Container>
  );
}
